import { Dialog, Icon, Tooltip, WithTooltip, AppTopNavi, Menu, MenuItem } from "@abb/abb-common-ux-react";
import React from "react";
import { Navbar } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { Input, Button } from "@abb/abb-common-ux-react";


import ConfigurationCard from "../shared/ConfigurationCard";
import AppNavbar from "./AppNavbar";
import { Translation } from "react-i18next";
import logoSettingStore from "../../flux/stores/settings/LogoSettingStore";
import triggerNotifications from "../../utilities/TriggerNotifications";
import loadingActions from "../../flux/actions/LoadingActions";
import settingsActions from "../../flux/actions/SettingsAction";
import userByIdStore from "../../flux/stores/user/ByIdStore";
import changePasswordStore from "../../flux/stores/user/ChangePasswordStore";
import userFormStore from "../../flux/stores/user/FormStore";
import userActions from "../../flux/actions/UserActions";
import { UserFormData, userPostData } from "../../models/user/UserFormData";

import MyIcon from "../../assets/Logo.png";
import History from "../../utilities/History";
import auth from "../../utilities/Auth";

import { ABB_CLOSE, ABB_CARET_DOWN, ABB_CARET_RIGHT, ABB_HIDE, ABB_VIEW } from "../../utilities/IconConstants";
import * as CONSTANTS from "../../utilities/Constants";
import Authorize from "../../utilities/Authorize";
import authUtility from '../../utilities/AuthUtility';



interface IProps {
  layout: string;
}

interface IConfigCardState {
  showConfigCard: boolean;
  showSampleCard: boolean;
  imageURL: string;
  isDialogVisible: boolean;
  showProfile: boolean;
  activeUser: any;
  showPasswordChange: boolean;
  oldpassword: string;
  newpassword: string;
  confirmpassword: string;
  isSubmitDisabled: boolean;
  isRevelPasswordNew: boolean;
  isRevelPasswordOld: boolean;
  isRevelPasswordConfirm: boolean;
  showProfileChange: boolean;
  profileSubmitDisabled: boolean;
  duplicateActiveUser: any;
  oldPasswordError: boolean;
  newPasswordError: boolean;
  confirmPasswordError: boolean;
  firstNameError:boolean;
  lastNameError: boolean;
  userImageText: string;
  emailError: boolean;
}

export default class Landing extends React.Component<IProps, IConfigCardState> {
  private activeUser = {}
  private editData = {}
  private passwordUpdate = ""
  private wrapperRef: any;

  constructor(props: any) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {
      showConfigCard: false,
      showSampleCard: false,
      imageURL: "",
      isDialogVisible: false,
      showProfile: false,
      activeUser: {},
      showPasswordChange: false,
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      isSubmitDisabled: true,
      isRevelPasswordOld: false,
      isRevelPasswordNew: false,
      isRevelPasswordConfirm: false,
      showProfileChange: false,
      profileSubmitDisabled: true,
      duplicateActiveUser: {},
      oldPasswordError: false,
      newPasswordError: false,
      confirmPasswordError: false,
      firstNameError:false,
      lastNameError: false,
      userImageText: "",
      emailError: false
    };
  }

  componentDidMount() {
    document.addEventListener("mouseup", (event: any) => {
      const container: any = document.getElementById("container");
      if (container && !container.contains(event.target)) {
      }
    });

    document.addEventListener("mousedown", this.handleOutsideClicks);

    this.storeCall();
    this.actionCall();
    let userID = auth.getUserId();
    userByIdStore.on('change', (state) => {
      this.activeUser = state.userData
      this.setState({duplicateActiveUser: JSON.parse(JSON.stringify(state.userData))});
    });
    changePasswordStore.on('change', (state) => {
      this.passwordUpdate = state.data
    });
    userFormStore.on('change', (state) => {
      const data = state.data;
    })
    this.triggerByID(userID)
  }

  triggerByID = (id: string) => {
    userActions.getById(id).then(() => {
      this.setState({activeUser: this.activeUser})
      const receivedData:any = this.activeUser;
      this.setState({userImageText: receivedData.firstName && receivedData.lastName ? `${receivedData.firstName.charAt(0).toUpperCase()}${receivedData.lastName.charAt(0).toUpperCase()}` : `${receivedData.firstName.charAt(0).toUpperCase()}`})
      this.editData = new UserFormData(true, uuidv4(), id, false, receivedData.firstName, receivedData.lastName, receivedData.email, receivedData.role, receivedData.username, receivedData.password);
    })
  }

  handleOutsideClicks = (event: any) => {
    const sampleCardContainer: any = document.getElementById("sampleContainer");
    const ConfigCardContainer: any = document.getElementById("configContainer");
    if (sampleCardContainer && !sampleCardContainer.contains(event.target)) {
      this.openSampleCard();
    } else if (
      ConfigCardContainer &&
      !ConfigCardContainer.contains(event.target)
    ) {
      this.closeConfigCard();
    }
  };

  public storeCall = () => {
    logoSettingStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (state.data) {
        this.setState({
          imageURL: state.data,
        });
      }
    });
  };

  public actionCall = () => {
    settingsActions
      .getLogoSetting()
      .then(() => {})
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  // Configuration  menu panel toggle
  closeConfigCard = () => {
    this.setState(
      {
        showConfigCard: !this.state.showConfigCard,
      },
      () => {
        if (this.state.showSampleCard) {
          this.setState({
            showSampleCard: false,
          });
        }
      }
    );
  };
  // Sample  menu panel toggle
  openSampleCard = () => {
    this.setState(
      {
        showSampleCard: !this.state.showSampleCard,
      },
      () => {
        if (this.state.showConfigCard) {
          this.setState({
            showConfigCard: false,
          });
        }
      }
    );
  };

  Logout = (e: any): void => {
    auth.removeTokens();
    History.push(CONSTANTS.LOGIN_URL);
  };

  formEmpty = () => {
    this.setState({
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      isSubmitDisabled: true,
      profileSubmitDisabled: true,
      duplicateActiveUser: JSON.parse(JSON.stringify(this.state.activeUser)),
      isRevelPasswordOld: false,
      isRevelPasswordNew: false,
      isRevelPasswordConfirm: false,
      oldPasswordError: false,
      newPasswordError: false,
      confirmPasswordError: false,
      firstNameError:false,
      lastNameError: false,
      emailError: false
    })
  }

  private showUserProfile = () => {
    this.setState({
      showProfile: !this.state.showProfile,
      showPasswordChange: false,
      showProfileChange: false
    },() => {
      this.state.showProfile ? document.addEventListener("mousedown", this.handleClickOutsideProfile) : 
      document.removeEventListener("mousedown", this.handleClickOutsideProfile);
    });
    this.formEmpty()
  };

  private editMyProfile = () => {
    this.setState({showProfileChange: !this.state.showProfileChange})
    this.setState({showPasswordChange: false})
    this.formEmpty()
  }

  private changePassword = () => {
    this.setState({showPasswordChange: !this.state.showPasswordChange})
    this.setState({showProfileChange: false})
    this.formEmpty()
  }

  private onCancelProfile = () => {
    this.setState({showProfileChange: false})
    this.formEmpty()
  }

  private onSaveProfile = () => {
    const data: userPostData = {
      userFormData: this.state.duplicateActiveUser,
      roleData: {},
      oldRoleData: {}
    }

    userActions.put(data).then(() => {
      triggerNotifications.success(["User Updated"])
      this.setState({showProfileChange: false})
      setTimeout(() => {
        this.triggerByID(this.state.activeUser.id)
      },200)
    }).catch((error: any) => {
        triggerNotifications.errors(error).then()
    });
  }

  private onCancelClick = () => {
    this.setState({showPasswordChange: false})
    this.formEmpty()
  }

  private onSaveClick = () => {
    this.setState({showProfile: false})
    const data = {
       oldPasssowrd: this.state.oldpassword,
       newPasssowrd: this.state.newpassword,
       confirmPasssowrd: this.state.confirmpassword
    }
    userActions.changePassword(data, this.state.activeUser.id).then(() => {
      setTimeout(() => {
        if(this.passwordUpdate){
        auth.removeTokens();
        History.push(CONSTANTS.LOGIN_URL);}
      }, CONSTANTS.NOTIFICATION_TIMEOUT);
    }).catch((error) => {
      triggerNotifications.errors(error).then()
    })
  }

  validate(): void {
    if (this.state.oldpassword && this.state.newpassword && this.state.confirmpassword && 
      !this.state.oldPasswordError && !this.state.newPasswordError && !this.state.confirmPasswordError
      ){
      this.setState({isSubmitDisabled: false})
    } else{
      this.setState({isSubmitDisabled: true})
    }
  }

  profileValidate(): void {
    if (this.state.duplicateActiveUser.firstName && this.state.duplicateActiveUser.lastName &&
      !this.state.firstNameError && !this.state.lastNameError && !this.state.emailError){
      this.setState({profileSubmitDisabled: false})
    } else{
      this.setState({profileSubmitDisabled: true})
    }
  }

  private togglePassword = (type:string) => {
    if(type === "oldPassword"){
      this.setState({
        isRevelPasswordOld: !this.state.isRevelPasswordOld,
      });
    }
    if(type === "newPassword"){
      this.setState({
        isRevelPasswordNew: !this.state.isRevelPasswordNew,
      });
    }
    if(type === "confirmPassword"){
      this.setState({
        isRevelPasswordConfirm: !this.state.isRevelPasswordConfirm,
      });
    }
  };

  private setFirstName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.firstName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        duplicateActiveUser,
        firstNameError: false
      },this.profileValidate)
    } else{
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.firstName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        duplicateActiveUser,
        firstNameError: true
      },this.profileValidate)
    }
  }

  private setLastName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.lastName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        duplicateActiveUser,
        lastNameError: false
      },this.profileValidate)
    } else{
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.lastName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        duplicateActiveUser,
        lastNameError: true
      },this.profileValidate)
    }
  }

  private setEmail = (value: string) => {
    if(value !== ""){
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.email = value;
      this.setState({
        duplicateActiveUser
      },this.profileValidate)
    } else{
      const duplicateActiveUser = this.state.duplicateActiveUser;
      duplicateActiveUser.email = value;
      this.setState({
        emailError: false
      },this.profileValidate)
    }
  }

  private emailValidation = (value: string) =>{
    if(value !== ""){
      if(value.trim() && (/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/.test(value))){
        this.setState({
          emailError: false
        },this.profileValidate)
      } else{
        this.setState({
          emailError: true
        },this.profileValidate)
      }
    }
  }

  private setOldPassword = (value: string) => {
    value.length !== 0 ? this.setState({oldPasswordError: false, oldpassword:value},this.validate) : 
    this.setState({oldPasswordError: true, oldpassword:value.replace(/\s/g, "")},this.validate)
  }

  private setNewPassword = (value: string) => {
    value.length !== 0 ? this.setState({newPasswordError: false, newpassword:value},this.validate) : 
    this.setState({newPasswordError: true, newpassword:value.replace(/\s/g, "")},this.validate)
  }

  private setConfirmPassword = (value: string) => {
    value.length !== 0 ? this.setState({confirmPasswordError: false, confirmpassword:value},this.validate) : 
    this.setState({confirmPasswordError: true, confirmpassword:value.replace(/\s/g, "")},this.validate)
  }

  private handleClickOutsideProfile = (event: any) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.showUserProfile();
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutsideProfile);
  }


  render() {
    return (
      <Translation>
        {(t) => (
          <div className="row topHeader">
            <div className="col-sm-6 col-xl-3">
              <Navbar bg="dark" variant="dark">
                <Container>
                  <Navbar.Brand href="/samplenew">
                    <div className="col-4 logo-div flex-start">
                      <img
                        className="logo d-inline-block align-top float-left"
                        width="52"
                        height="20"
                        src={MyIcon}
                        alt={t(CONSTANTS.NO_IMAGE_FOUND)}
                      />
                    </div>
                    <div className="logoRight float-left d-inline-block">
                      <span className="divider"></span>
                      <span className="subText">
                        {t(CONSTANTS.PRODUCT_NAME)}
                      </span>
                      <span className="version">
                        <sub>{t(CONSTANTS.VERSION)}</sub>
                      </span>
                    </div>
                  </Navbar.Brand>
                </Container>
              </Navbar>
            </div>
            <div className="col-xl-6 justify-content-center navContainer">
              {this.props.layout === "mainlayout" && (
                <AppNavbar
                  openConfigCard={this.closeConfigCard}
                  openSampleCard={this.openSampleCard}
                ></AppNavbar>
              )}
            </div>

            {/* Configuration  menu panel start*/}
            {this.state.showConfigCard && (
              <div id="configContainer">
                <ConfigurationCard />
              </div>
            )}
            {/* Configuration  menu panel end*/}

            {/* Sample  menu panel start*/}
            {this.state.showSampleCard && (
              <div id="sampleContainer">
                <div className="configCard sampleCard">
                  <div className="row" style={{ marginLeft: "2px" }}>
                    <div className="col-md-12 col-lg-12 col-xl-12 cardHeader">
                      <ul className="navbar-nav">
                        <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}`]}>
                          <li>
                            <a href={CONSTANTS.SAMPLE_INDEXNEW_URL}>
                              {t(CONSTANTS.MENU_SAMPLE_MEASUREMENT)}
                            </a>
                          </li>
                        </Authorize>
                        {authUtility.hasPermission([`${CONSTANTS.AUTHKEY_INSTRUMENT}`]) &&
                          <li>
                            <a href={CONSTANTS.INSTRUMENT_INDEX_URL}>
                              {t(CONSTANTS.MENU_INSTRUMENTMEASUREMENT)}
                            </a>
                          </li>}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Sample  menu panel end*/}

            {/* My Profile start*/}
            <div className="col-sm-6 col-xl-3 topRightContainer justify-content-right" ref={this.wrapperRef}>
              <ul className="navbar-nav mr-auto d-block float-right">
                <li className="nav-item">
                    {this.state.activeUser?.firstName && <span className="nameHeader name-font-family">{`${this.state.activeUser?.firstName} ${this.state.activeUser?.lastName}`}</span>}
                    <Icon className="cursor-pointer" name="abb/user-in-circle" sizeClass="medium" onClick={this.showUserProfile} />
                </li>
                {this.state.showProfile && (
                  <div
                  className="ul-class profile-shadow profile-color"
                  style={{ right: 0, zIndex: 1001, width: "300px" }}
                  > 
                  <div className="profileCardWrapper">
                    <div className="profileCard">
                      <span className="myAccount">{t(CONSTANTS.MY_PROFILE)}</span>
                      <span className="close cursor-pointer" onClick={this.showUserProfile}><Icon name={ABB_CLOSE} /></span>
                    </div>
                    <div className="userWrapper">
                    <div className="userImageWrapper">
                      <p className="userImage">{this.state.userImageText}</p></div>
                    <div className="userDetail">
                    {this.state.activeUser.lastName ? (<WithTooltip>
                    <div className="text-ellipsis width-10rem userName">{`${this.state.activeUser.firstName} ${this.state.activeUser.lastName}` || CONSTANTS.LABEL_ADMIN}</div>
                      <Tooltip className="nav-tooltip">
                        <p>{`${this.state.activeUser.firstName} ${this.state.activeUser.lastName}` || CONSTANTS.LABEL_ADMIN}</p>
                      </Tooltip>
                    </WithTooltip>) : (<WithTooltip>
                    <div className="text-ellipsis width-10rem userName">{`${this.state.activeUser.firstName}` || CONSTANTS.LABEL_ADMIN}</div>
                      <Tooltip className="nav-tooltip">
                        <p>{`${this.state.activeUser.firstName}` || CONSTANTS.LABEL_ADMIN}</p>
                      </Tooltip>
                    </WithTooltip>)}
                    {this.state.activeUser.email && <WithTooltip>
                    <div className="text-ellipsis width-10rem userEmail">{this.state.activeUser.email}</div>
                      <Tooltip className="nav-tooltip">
                        <p>{this.state.activeUser.email}</p>
                      </Tooltip>
                    </WithTooltip>}
                    <WithTooltip>
                    <div className="text-ellipsis width-10rem userName">{this.state.activeUser?.username}</div>
                      <Tooltip className="nav-tooltip">
                        <p>{this.state.activeUser?.username}</p>
                      </Tooltip>
                    </WithTooltip>
                    <WithTooltip>
                    <div className="text-ellipsis width-10rem userName">{this.state.activeUser?.role?.name}</div>
                      <Tooltip className="nav-tooltip">
                        <p>{this.state.activeUser?.role?.name}</p>
                      </Tooltip>
                    </WithTooltip>
                    <WithTooltip>
                    <div className="text-ellipsis width-10rem editProfile cursor-pointer" onClick={this.editMyProfile}>
                      <span style={{textDecoration: "underline"}}>{t(CONSTANTS.EDIT_MY_PROFILE)}</span>
                      <Icon name={this.state.showProfileChange ? ABB_CARET_DOWN : ABB_CARET_RIGHT} sizeClass="medium" />
                    </div>
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.EDIT_MY_PROFILE)}</p>
                      </Tooltip>
                    </WithTooltip>
                    <WithTooltip>
                    <div className="text-ellipsis width-10rem changePassword cursor-pointer" onClick={this.changePassword}>
                      <span style={{textDecoration: "underline"}}>{t(CONSTANTS.CHANGE_PASSWORD)}</span>
                      <Icon name={this.state.showPasswordChange ? ABB_CARET_DOWN : ABB_CARET_RIGHT} sizeClass="medium" />
                    </div>
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.CHANGE_PASSWORD)}</p>
                      </Tooltip>
                    </WithTooltip>
                    <WithTooltip>
                    <div className="text-ellipsis width-10rem changePassword cursor-pointer" onClick={() => this.setState({ isDialogVisible: true })}>
                      <span style={{textDecoration: "underline"}}>{t(CONSTANTS.LOGOUT)}</span>
                    </div>
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.LOGOUT)}</p>
                      </Tooltip>
                    </WithTooltip>
                    </div>
                    </div>
                    {this.state.showProfileChange && (<div className="passwordForm">
                      <form style={{width: "100%", marginBottom: "20px"}}>
                      <div className="row mr0">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.firstNameError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            dataType="text"
                            placeholder={t(CONSTANTS.LABEL_FIRST_NAME)}
                            label={t(CONSTANTS.LABEL_FIRST_NAME)}
                            required={true}
                            value={this.state.duplicateActiveUser.firstName}
                            onValueChange={this.setFirstName}
                            showValidationBarWhenInvalid={this.state.firstNameError}
                            maxLength={50}
                            description={
                              this.state.firstNameError ?
                              this.state.duplicateActiveUser.firstName !== "" ? 
                              t(CONSTANTS.FIRSTNAME_VALIDATION_ERROR) :
                              t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.lastNameError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            dataType="text"
                            placeholder={t(CONSTANTS.LABEL_LAST_NAME)}
                            label={t(CONSTANTS.LABEL_LAST_NAME)}
                            required={true}
                            value={this.state.duplicateActiveUser.lastName}
                            onValueChange={this.setLastName}
                            showValidationBarWhenInvalid={this.state.lastNameError}
                            maxLength={50}
                            description={
                              this.state.lastNameError ?
                              this.state.duplicateActiveUser.lastName !== "" ? 
                              t(CONSTANTS.LASTNAME_VALIDATION_ERROR) :
                              t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md">
                          <Input
                            dataType="email"
                            label={t(CONSTANTS.LABEL_EMAIL)}
                            placeholder={t(CONSTANTS.LABEL_EMAIL)}
                            required={false}
                            value={this.state.duplicateActiveUser.email}
                            onValueChange={this.setEmail}
                            className={
                              this.state.emailError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            showValidationBarWhenInvalid={this.state.emailError}
                            onLostFocus={() => this.emailValidation(this.state.duplicateActiveUser.email)}
                            onGotFocus={() => this.setState({emailError: false})}
                            description={
                              this.state.emailError ?
                              t(CONSTANTS.EMAIL_VALIDATION_ERROR) : ""
                            }
                            maxLength={72}
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md buttonWrapper">
                        <Button
                          style={{ margin: "0px 4px" }}
                          type="primary-black"
                          shape="pill"
                          className="spinner-position"
                          text={t(CONSTANTS.BUTTON_CANCEL)}
                          icon="abb/close"
                          onClick={this.onCancelProfile}
                        />
                        <Button
                          disabled={this.state.profileSubmitDisabled}
                          type="primary-black"
                          shape="pill"
                          className="spinner-position"
                          text={t(CONSTANTS.BUTTON_SAVE)}
                          icon="abb/check-mark"
                          onClick={this.onSaveProfile}
                        />
                        </div>
                      </div>
                    </form>
                    </div>)}
                    {this.state.showPasswordChange && (<div className="passwordForm">
                      <form style={{width: "100%", marginBottom: "20px"}}>
                      <div className="row mr0">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.oldPasswordError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            dataType={
                              this.state.isRevelPasswordOld ? "text" : "password"
                            }
                            label={t(CONSTANTS.OLD_PASSWORD)}
                            placeholder={t(CONSTANTS.OLD_PASSWORD)}
                            required={true}
                            onValueChange={(value) => this.setOldPassword(value)}
                            value={this.state.oldpassword}
                            showValidationBarWhenInvalid={this.state.oldPasswordError}
                            icon={
                              this.state.isRevelPasswordOld ? ABB_VIEW : ABB_HIDE
                            }
                            onIconClick={() => this.togglePassword("oldPassword")}
                            maxLength={15}
                            description={
                              this.state.oldPasswordError ? t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.newPasswordError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            dataType={
                              this.state.isRevelPasswordNew ? "text" : "password"
                            }
                            label={t(CONSTANTS.NEW_PASSWORD)}
                            placeholder={t(CONSTANTS.NEW_PASSWORD)}
                            required={true}
                            onValueChange={(value) => this.setNewPassword(value)}
                            value={this.state.newpassword}
                            showValidationBarWhenInvalid={this.state.newPasswordError}
                            icon={
                              this.state.isRevelPasswordNew ? ABB_VIEW : ABB_HIDE
                            }
                            onIconClick={() => this.togglePassword("newPassword")}
                            maxLength={15}
                            description={
                              this.state.newPasswordError ? t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.confirmPasswordError
                                ? "error-code mt-2 w-100"
                                : "mt-2 w-100"
                            }
                            dataType={
                              this.state.isRevelPasswordConfirm ? "text" : "password"
                            }
                            label={t(CONSTANTS.CONFIRM_PASSWORD)}
                            placeholder={t(CONSTANTS.CONFIRM_PASSWORD)}
                            required={true}
                            onValueChange={(value) => this.setConfirmPassword(value)}
                            value={this.state.confirmpassword}
                            showValidationBarWhenInvalid={this.state.confirmPasswordError}
                            icon={
                              this.state.isRevelPasswordConfirm ? ABB_VIEW : ABB_HIDE
                            }
                            onIconClick={() => this.togglePassword("confirmPassword")}
                            maxLength={15}
                            description={
                              this.state.confirmPasswordError ? t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3 mr0">
                        <div className="col-sm col-md buttonWrapper">
                        <Button
                          style={{ margin: "0px 4px" }}
                          type="primary-black"
                          shape="pill"
                          className="spinner-position"
                          text={t(CONSTANTS.BUTTON_CANCEL)}
                          icon="abb/close"
                          onClick={this.onCancelClick}
                        />
                        <Button
                          disabled={this.state.isSubmitDisabled}
                          type="primary-black"
                          shape="pill"
                          className="spinner-position"
                          text={t(CONSTANTS.BUTTON_SAVE)}
                          icon="abb/check-mark"
                          onClick={this.onSaveClick}
                        />
                        </div>
                      </div>
                      </form>
                      </div>)}
                  </div>
                  </div>
                )}
              </ul>
            </div>
            {/* My Profile end*/}
            <Dialog
              isOpen={this.state.isDialogVisible}
              onClose={() => this.setState({ isDialogVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.Logout,
                },
                {
                  text: t(CONSTANTS.BUTTON_CLOSE),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
              ]}
            >
              <div>{t(CONSTANTS.LOGOUT_DIALOG_CONTENT)}</div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}
